import { Navigate } from 'react-router-dom';
import { getAccessToken } from '../../utils/session';

// Access of Routes For logged in user
const PrivateRoute = ({ children }) => {
    const isLogin = getAccessToken()

    return isLogin ? children : <Navigate to='/login' />
}
export default PrivateRoute;